module.exports = "fragment DetailedGroupFragment on Group {\n  ...GroupFragment\n  contacts: members {\n    ...ContactFragment\n  }\n}\n"